export default "/assets/Icon/Select_On.svg"